import ArrowRight from 'assets/svg/arrow/arrow_right.svg'
import Flex from 'common/components/Flex'
import theme from 'common/theme'
import { useState } from 'react'
import styled from 'styled-components'

const PerusahaanContainer = styled(Flex)`
  background: transparent;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  text-wrap: nowrap;
  min-width: 147px;
  gap: 8px;
`

const LeftMenuSection = styled.div`
  flex: 1;
  background: #f8f9fa;
  padding: 16px;
`

const RightMenuSection = styled.div`
  flex: 1;
  background: #f8f9fa;
  padding: 16px;
  transition: opacity 0.3s ease;
  display: ${({ show }) => (show ? 'inline-block' : 'none')};
`

const MenuCategory = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`

const MenuItemLink = styled.a`
  ${theme.typography.rsubtitle}
  display: flex;
  padding: 12px;
  margin-bottom: 4px;
  align-items: center;
  color: ${theme.colors.black};
  border-radius: 8px;
  cursor: pointer;
  background-color: transparent;
  font-weight: ${({ active }) => (active ? 700 : 400)};
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    font-weight: 700;
    background-color: ${theme.colors.grayLighter};
  }
`

const RightMenuItem = styled.a`
  ${theme.typography.rsubtitle}
  display: flex;
  padding: 12px;
  margin-bottom: 8px;
  align-items: center;
  color: ${theme.colors.black};
  border-radius: 8px;
  cursor: pointer;
  background-color: transparent;
  font-weight: 400;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    font-weight: 700;
    background-color: ${theme.colors.grayLighter};
  }
`

const ArrowIcon = styled(ArrowRight)`
  transform: scale(0.5);
  margin-left: 8px;
  fill: black;
`

const PerusahaanPopover = (): JSX.Element => {
  const [activeRightMenu, setActiveRightMenu] = useState<String>('')

  const handleEcosystemHover = (activeSection: String) => {
    setActiveRightMenu(activeSection)
  }

  const handleMouseLeave = () => {
    setActiveRightMenu('')
  }

  const ecosystemItems = [
    { name: 'Kalibrasi.com', url: 'https://www.kalibrasi.com' },
    { name: 'Rbiz', url: 'https://rbiz.co.id' },
    { name: 'Limbah.id', url: 'https://www.limbah.id' },
  ]

  return (
    <PerusahaanContainer onMouseLeave={handleMouseLeave}>
      <LeftMenuSection>
        <MenuCategory>
          <MenuItemLink
            onMouseEnter={() => handleEcosystemHover('')}
            href="https://www.ralali.com/tentangkami"
          >
            Tentang Kami
          </MenuItemLink>
          <MenuItemLink
            onMouseEnter={() => handleEcosystemHover('')}
            href="https://www.ralaligroup.com"
            target="_blank"
          >
            Ralali Group
          </MenuItemLink>
          <MenuItemLink
            href="#"
            onMouseEnter={() => handleEcosystemHover('ecosystem')}
            active={activeRightMenu === 'ecosystem'}
          >
            Ralali Ekosistem
            <ArrowIcon />
          </MenuItemLink>
        </MenuCategory>
      </LeftMenuSection>

      <RightMenuSection show={activeRightMenu === 'ecosystem'}>
        {ecosystemItems.map((item) => (
          <RightMenuItem
            key={item.name}
            href={item.url}
            target="_blank"
          >
            {item.name}
          </RightMenuItem>
        ))}
      </RightMenuSection>
    </PerusahaanContainer>
  )
}

export default PerusahaanPopover
